import Svg from "components/Svg";
import PropTypes from "prop-types";
import "./PageLoader.scss";
/**
 *
 * @param {*} props
 */
const PageLoader = (props) => {
    const { className } = props;

    return (
        <div className={`page-loader ${className || ""}`}>
            <Svg icon="elementLoader" />
        </div>
    );
};

PageLoader.defaultProps = {
    className: "",
};

PageLoader.propTypes = {
    className: PropTypes.string,
};

export default PageLoader;
